var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgExp = function SvgExp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0476 10.672L17.8746 9.57469L14.6594 2.71614C14.4193 2.20399 13.5803 2.20399 13.3401 2.71614L10.126 9.57469L2.95294 10.672C2.36378 10.7626 2.1285 11.4802 2.5417 11.9037L7.75279 17.2531L6.52099 24.8156C6.4228 25.4163 7.06349 25.8671 7.59335 25.5721L14.0003 22.026L20.4072 25.5731C20.9322 25.8652 21.5787 25.4232 21.4796 24.8166L20.2478 17.254L25.4589 11.9047C25.872 11.4802 25.6358 10.7626 25.0476 10.672Z",
    fill: "#FEA832"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1784_71862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0847 16.2405V17.1269H8.44482V12.332H12.0309V13.2185H9.49917V14.246H11.8228V15.0653H9.49917V16.2405H12.0847ZM14.5493 15.4682L13.4815 17.1269H12.2996L13.9717 14.6153L12.4272 12.332H13.6494L14.5896 13.8632L15.5633 12.332H16.7184L15.1805 14.622L16.8527 17.1269H15.5969L14.5493 15.4682ZM18.3301 17.1269V15.4078H19.4382C19.7382 15.4078 19.9934 15.3641 20.2038 15.2768C20.4142 15.1895 20.5854 15.0742 20.7175 14.931C20.8496 14.7877 20.9458 14.6232 21.0063 14.4374C21.0667 14.2516 21.0969 14.0624 21.0969 13.8699C21.0969 13.6729 21.0667 13.4826 21.0063 13.2991C20.9458 13.1155 20.8496 12.9521 20.7175 12.8088C20.5854 12.6656 20.4142 12.5503 20.2038 12.463C19.9934 12.3757 19.7382 12.332 19.4382 12.332H17.2758V17.1269H18.3301ZM18.3301 14.5885H19.1494C19.2703 14.5885 19.3867 14.5795 19.4986 14.5616C19.6106 14.5437 19.7091 14.509 19.7941 14.4575C19.8792 14.406 19.9475 14.3333 19.999 14.2393C20.0504 14.1452 20.0762 14.0221 20.0762 13.8699C20.0762 13.7177 20.0504 13.5946 19.999 13.5005C19.9475 13.4065 19.8792 13.3338 19.7941 13.2823C19.7091 13.2308 19.6106 13.1961 19.4986 13.1782C19.3867 13.1603 19.2703 13.1513 19.1494 13.1513H18.3301V14.5885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0847 16.2405V17.1269H8.44482V12.332H12.0309V13.2185H9.49917V14.246H11.8228V15.0653H9.49917V16.2405H12.0847ZM14.5493 15.4682L13.4815 17.1269H12.2996L13.9717 14.6153L12.4272 12.332H13.6494L14.5896 13.8632L15.5633 12.332H16.7184L15.1805 14.622L16.8527 17.1269H15.5969L14.5493 15.4682ZM18.3301 17.1269V15.4078H19.4382C19.7382 15.4078 19.9934 15.3641 20.2038 15.2768C20.4142 15.1895 20.5854 15.0742 20.7175 14.931C20.8496 14.7877 20.9458 14.6232 21.0063 14.4374C21.0667 14.2516 21.0969 14.0624 21.0969 13.8699C21.0969 13.6729 21.0667 13.4826 21.0063 13.2991C20.9458 13.1155 20.8496 12.9521 20.7175 12.8088C20.5854 12.6656 20.4142 12.5503 20.2038 12.463C19.9934 12.3757 19.7382 12.332 19.4382 12.332H17.2758V17.1269H18.3301ZM18.3301 14.5885H19.1494C19.2703 14.5885 19.3867 14.5795 19.4986 14.5616C19.6106 14.5437 19.7091 14.509 19.7941 14.4575C19.8792 14.406 19.9475 14.3333 19.999 14.2393C20.0504 14.1452 20.0762 14.0221 20.0762 13.8699C20.0762 13.7177 20.0504 13.5946 19.999 13.5005C19.9475 13.4065 19.8792 13.3338 19.7941 13.2823C19.7091 13.2308 19.6106 13.1961 19.4986 13.1782C19.3867 13.1603 19.2703 13.1513 19.1494 13.1513H18.3301V14.5885Z",
    fill: "url(#paint0_linear_1784_71862)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1784_71862",
    x: 7.44482,
    y: 11.332,
    width: 14.6523,
    height: 6.79297,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.59518 0 0 0 0 0.0397294 0 0 0 0.434659 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1784_71862"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1784_71862",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1784_71862",
    x1: 8.44482,
    y1: 12.332,
    x2: 8.44482,
    y2: 17.1269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE780"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/exp.e6381fb0c72a86eb7288d13d9b2e5bb8.svg";